import { useCompanyQuery } from '../graphql/query/company.query'
import { useAppSelector } from '../store'
import { ID } from '../utils/id'
import { useProfile } from './use.profile'

interface Permissions {
  isAdmin: boolean
  isMember: boolean
  isWorker: boolean
  isStaff: boolean
  loading: boolean
}

interface Options {
  company?: ID
}

export const usePermission = (options: Options = {}): Permissions => {
  const storedCompanyId = useAppSelector((state) => state.company.id)

  const companyId = options.company ?? storedCompanyId

  const company = useCompanyQuery({
    skip: !companyId,
    variables: {
      // never sent: the query is skipped while no company is set
      id: companyId ?? '',
    },
  })

  const profile = useProfile()

  return {
    isAdmin: company.data?.company?.isAdmin ?? false,
    isMember: company.data?.company?.isMember ?? false,
    isStaff: profile.profile?.isStaff ?? false,
    isWorker: company.data?.company?.isWorker ?? false,
    loading: company.loading || profile.loading,
  }
}
